import { Box, Grid2, Paper, Typography, useTheme } from '@mui/material'

import ToothGraphic6 from '@/assets/images/Tooth-graphic-6.svg'
import Chip from '@/components/Chip'
import PieChart from '@/components/PieChart'
import { isNullorEmpty } from '@/utils'
import { pieChartSections } from '@/utils/constants'

type StumpShadePDFProps = {
  recipeOutput: any
  natural_die_material: string
}

const PieChartCard = ({
  title,
  labels,
  values,
}: {
  title: string
  labels?: string[]
  values?: number[]
}) => {
  if (!labels?.length || !values?.length) return null

  return (
    <Paper
      elevation={3}
      sx={{
        flex: 1,
        p: 3,
        textAlign: 'center',
        borderRadius: '16px',
        color: 'black',
        height: '100%',
        maxWidth: '31%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'white',
        boxShadow: 'none',
      }}
    >
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        gap={1}
        mb={1}
      >
        <Typography variant="h4" fontWeight="bold">
          {title}
        </Typography>
      </Box>
      <Box display="flex" justifyContent="center" alignItems="center">
        <PieChart labels={labels} values={values} />
      </Box>
    </Paper>
  )
}

const StumpShadePDF = ({
  recipeOutput,
  natural_die_material,
}: StumpShadePDFProps) => {
  const theme = useTheme()

  return (
    <Box
      display="flex"
      mt={1}
      // height="100%"
      sx={{
        color: 'black',
        borderBottom: '1px solid #000',
        marginBottom: '8px',
        background: 'white',
      }}
    >
      <Box sx={{ width: '30%' }}>
        <img
          style={{ width: '270px', height: '380px' }}
          src={ToothGraphic6}
          alt="Toothimage"
        />
      </Box>
      <Box
        flex={1}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="start"
        mt={1}
        height="100%"
        sx={{
          color: 'black',
        }}
      >
        <Box
          display="flex"
          flex={1}
          justifyContent="center"
          alignItems="center"
          my={2}
          gap={1}
        >
          <Typography
            sx={{ fontSize: '1.5rem', fontWeight: 500, color: '#000' }}
          >
            Stump Shade:
          </Typography>
          {isNullorEmpty(natural_die_material) && (
            <Chip
              label={natural_die_material}
              sx={{
                bgcolor: theme.palette.background.chip,
                fontSize: '16px',
                color: theme.palette.common.black,
                '&:hover': {
                  bgcolor: theme.palette.background.chip,
                },
              }}
            />
          )}
        </Box>

        <Grid2
          container
          spacing={3}
          justifyContent="center"
          alignItems="stretch"
          mb={2}
          columns={3}
          width="100%"
        >
          {pieChartSections?.map(({ key, label }) => {
            const chartDetail = recipeOutput?.[`aestheticmodel_${key}`] || {}
            return (
              <PieChartCard
                key={key}
                title={label}
                labels={chartDetail.prep_names || []}
                values={chartDetail.prep_ratios || []}
              />
            )
          })}
        </Grid2>
      </Box>
    </Box>
  )
}

export default StumpShadePDF
